import { DefaultLogger } from "./Logger";
import { OutlookActions } from "./OutlookActions";
import { ApmBase } from '@elastic/apm-rum';

export enum AppointMentRecipientType {
    REQUIRED = 'requiredAttendees',
    OPTIONAL = 'optionalAttendees'
  };

export class AppointmentOutlookActions extends OutlookActions<AppointMentRecipientType> {

    constructor(logger: DefaultLogger, apm: ApmBase) {
        super(logger, apm);
    }

  // Retrieves the requested appointmend attendees field from the current email item
  protected getRecipientField(recipientType: AppointMentRecipientType): Office.Recipients {
    switch (recipientType) {
      default:
      case AppointMentRecipientType.REQUIRED:
        return this.emailItem[AppointMentRecipientType.REQUIRED];
      case AppointMentRecipientType.OPTIONAL:
        return this.emailItem[AppointMentRecipientType.OPTIONAL];
    }
  }

  /**
   * Adds a custom property to email appointment item -- headers not available
   *
   * @param headerName the name of the header to add -- custom property actually
   * @param value the value of the custom property
   */
  public setHeaderToOutlook(headerName: string, value: string): Promise<void> {
    return new Promise((resolve, reject) => {
      // Handle appointment item with custom properties
      Office.context.mailbox.item.loadCustomPropertiesAsync((result) => {
          if (result.status === Office.AsyncResultStatus.Failed) {
              reject(this.createError('Failed to load custom properties.', result));
          }
          const customProps = result.value;
          customProps.set(headerName, value);
          customProps.saveAsync((saveResult) => {
              if (saveResult.status === Office.AsyncResultStatus.Failed) {
                  reject(this.createError('Failed to save custom properties.', saveResult));
              }
              resolve();
          });
      });
    });
  }
}